import { createFileRoute } from '@tanstack/react-router'
import Step1SelectType from '@/pages/account/twc/_components/JoinOrganizationForTwcPage/Step1SelectType'

export const Route = createFileRoute('/app/account/twc/join/')({
  component: RouteComponent,
})

function RouteComponent() {
  return <Step1SelectType />
}
